import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    inboxId: '',  // 收件箱id
    draftsId: '', // 草稿箱id
  },
  mutations: {
    getInboxId(state, inboxId){
      state.inboxId = inboxId
    },
    getDraftsId(state, draftsId){
      state.draftsId = draftsId
    },
  },
  actions: {
    
  },
  getters:{
    
  },
  modules: {
  }
})
